import React, { useRef } from "react";

import InputText from "@app/components/2_widgets/inputs/InputText";
import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";
import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import { useNavigate } from "react-router-dom";

import { UserPlus } from "lucide-react";
import { initCustomerObject } from "@app/utils/form_data_builders/CustomerFormDataBuilder";

export default function SectionCreateCustomer({createCustomer}) {
    const refName = useRef();
    const auth = useAuth();

    const navigate = useNavigate();

    function callback(event) {
        event.preventDefault();

        let customer = initCustomerObject();
        customer.company_name = refName.current.getValue();

        if (createCustomer)
            createCustomer(customer);
    }

    return (
        <div>
            <div className="section-title">
                <h3 className="title"><UserPlus /> Ou créer un prospect sans SIREN</h3>
            </div>

            <div className="row align-items-center">
                <div className="col-10">
                    <InputText
                        ref={refName}
                        inputId="text-name"
                        placeholder="Nom de l'entreprise..."
                    />
                </div>
                <div className="col-2 mb-3">
                    <ButtonPrimary label="Créer" onClick={callback}/>
                </div>
            </div>
            <span className="light-text">Le SIREN sera requis pour passer en dossier CSPE complet</span>
        </div>
    )
}